import { systemCode, xs_languageCode } from "../..";
import { getUrlPathSeoSettings } from "../utils/getUrlPathSeoSettings";
import { getUrlPath } from "../util/getUrlPath";
import { getAggregationAndBetFromBetIdAndSportId } from "./getAggregationAndBetFromBetIdAndSportId";
import { getBetDescription } from "./getBetDescription";
import { getConfiguration } from "./configuration";
import { getPrintableAmount } from "./getPrintableAmount";
import { calculateBetBuilderOdd } from "./calculateBetBuilderOdd";

export function getDataAndSelectionsFromBetslipTicketDTO(ticket) {
	const conf = getConfiguration();
	const nDec = conf.cs.nd;
	const mult = conf.cs.m;
	const purchaseType = ticket.purchaseType;
	// TO BE RETURNED
	const selections = [];
	const isBetBuilder = ticket.betBuilderOdd > 0;
	const betBuilderSelections = isBetBuilder? {} : null;
	let amount = ticket.amount;
	let systemSelections = null;
	
	if (purchaseType === 'systembets' || amount == 0) {
		amount = purchaseType === 'systembets'? conf.cs.imqfs: conf.cs.imqf;
	}
	if (ticket.taxOnStake) {
		amount += ticket.taxOnStake;
	}
	for (let k in ticket.events) {
		const event = ticket.events[k];
		const eventSelection = {};
		eventSelection.pal = event.pal;
		eventSelection.avv = event.avv;
		eventSelection.banker = false;
		eventSelection.descEvent = event.descAvv;
		eventSelection.isLive = event.live;
		eventSelection.alias = event.alias;
		eventSelection.descSport = event.descSport;
		eventSelection.descTournament = event.descTournament;
		eventSelection.timestamp = event.timestamp;
		eventSelection.sportId = event.sportRef || event.sportId;
		eventSelection.tournamentId = event.tournamentId;
		eventSelection.categoryId = event.categoryId;
		eventSelection.banker = event.fixed;
		eventSelection.closed = event.closed;
		try {
			const seoSettingsAdds = {[systemCode]:{[xs_languageCode]:{nf:true}}}; //nofollow,noindex
			eventSelection.matchData = {
				urlPath: getUrlPath({uniqueId: `${event.sportId}_${event.categoryId}_${event.tournamentId}`, urlPath: `${event.descSport}/${event.descTournament}`}, {p:event.pal,a:event.avv}, event.descAvv),
				urlPathSeoSettings: getUrlPathSeoSettings({seoSettingsAdds:JSON.stringify(seoSettingsAdds)})
			};
		}catch(err) {
			console.error(err);
		}
		
		const bets = [];
		for (let km in event.bets) {
			const bet = event.bets[km];
			let betDataAggr = getAggregationAndBetFromBetIdAndSportId(eventSelection.sportId, bet.scomSogei, bet.handicap);
			let betFromAgg = betDataAggr.market;
    		const addedBet = {};
    		addedBet.scomSogei = bet.scomSogei;
    		addedBet.handicap = bet.handicap;
    		addedBet.cs = bet.scomSogei;
    		addedBet.h = bet.handicap;
    		addedBet.descBet = bet.rawDescScom;
    		addedBet.descDraw = bet.rawDescDraw;
    		addedBet.draw = bet.codDraw;
    		addedBet.odd = bet.odd + "";
    		addedBet.dia = bet.dia;
    		
    		addedBet.legabile = false;
    		
    		if (betFromAgg != null) {
    			addedBet.legabile = betFromAgg.legabile;
    			addedBet.descBet = betFromAgg.desc;
				for(let ko in betFromAgg.odds) {
					if(betFromAgg.odds[ko].id === bet.codDraw) {
						addedBet.descDraw = betFromAgg.odds[ko].desc;
					}
				}
				addedBet.descBet = getBetDescription(addedBet, false, eventSelection.sportId , null);
    		}
    		addedBet.amount = amount; // for singlebet
    		addedBet.printableAmount = getPrintableAmount(addedBet.amount, mult, nDec); // for singlebet
    		bets.push(addedBet);
			
		}
		if(isBetBuilder && bets.length > 1){
			const betBuilderType = ticket.betBuilderOdd == 1? 'ITALIA' : 'ESTERO';

			// creo il mercato contenitore
			const betBuilderMarket = {
				subMarketsSet : bets,
	    		isBetBuilderMarket : true,
	    		odd : betBuilderType === 'ITALIA'? calculateBetBuilderOdd(bets) : ticket.betBuilderOdd	
			}
			eventSelection.bets = [betBuilderMarket];
			const keyAvv = eventSelection.pal + "_" + eventSelection.avv;
			betBuilderSelections[keyAvv] = {
				pal : eventSelection.pal,
				avv : eventSelection.avv,
				sportId : eventSelection.sportId,
				betBuilderMarket
			}
		}
		else {
			eventSelection.bets = bets;
		}
		selections.push(eventSelection);
	}
	
	// creazione id fittizi
	if(betBuilderSelections){
		let index = 1;
		for(let kb in betBuilderSelections){
			const bbm = betBuilderSelections[kb].betBuilderMarket;
			bbm.scomSogei = "bb" + index;
			bbm.draw = 0;
			bbm.handicap = 0;
			index ++;
		}
	
	}
	if (ticket.purchaseType === 'systembets' && selections.length > 0) {
		systemSelections = {};
		for (let kt in ticket.tuples) {
			const tupla = ticket.tuples[kt];
			const kc = tupla.id;
			systemSelections[kc] = {};
			systemSelections[kc].selected = true;
			systemSelections[kc].amount = tupla.amount;
			systemSelections[kc].printableAmount = getPrintableAmount(tupla.amount, mult, nDec);
			systemSelections[kc].vMin = 0;
			systemSelections[kc].vMax = 0;
		}
	}
	
	
	return {
		selections,
		systemSelections,
		amount,
		betBuilderSelections
	}
}
